import { useAuth } from '@/contexts/AuthContext';
import { useTeamContext } from '@/contexts/TeamContext';
import { Team } from '@/hooks/useTeams';

interface UseSubscriptionFlowProps {
  newTeam?: Team | null; // Optional team that was just created
}

export const useSubscriptionFlow = ({
  newTeam,
}: UseSubscriptionFlowProps = {}) => {
  const { signOut } = useAuth();
  const { setActiveTeam, teams } = useTeamContext();

  const handleSubscriptionComplete = async () => {
    // If this was after creating a new team, switch to it
    if (newTeam) {
      await setActiveTeam(newTeam);

      return;
    }
  };

  const handleNoSubscription = async () => {
    // Find a team that has a subscription
    const teamWithSubscription = teams.find((team) => team.subscription);

    if (teamWithSubscription) {
      // Switch to the first team that has a subscription
      await setActiveTeam(teamWithSubscription);
    } else {
      // If no teams have a subscription, log out
      await signOut();
    }
  };

  return {
    handleSubscriptionComplete,
    handleNoSubscription,
  };
};
